export default "__VITE_PUBLIC_ASSET__a3f94f13__"